<main class="container ">
  <div class="card">
    <div class="cross-btn">
      <button (click)="closePopup()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <img src="{{userDetails?.profile_picture}}" alt="User image" class="card__image"
      (click)="openPeepsoProfile(userDetails?.peepso_profile_url,'')" />
    <div class="card__text">
      <h2>{{userDetails?.name}}</h2>
      <p>I enjoy drinking a cup of coffee every day</p>
    </div>
    <ul class="card__info">
      <li>
        <span class="card__info__stats">{{userDetails?.posts}}</span>
        <span>posts</span>
      </li>
      <li>
        <span class="card__info__stats">{{userDetails?.followers}}</span>
        <span>followers</span>
      </li>
      <li>
        <span class="card__info__stats">{{userDetails?.following}}</span>
        <span>following</span>
      </li>
    </ul>
    <div class="card__action">
      <!-- <button class="card__action__button card__action--follow" (click)="followFriend(userDetails?.peepso_profile_url,userDetails?.follow)">{{userDetails?.follow}}</button> -->
      <button class="card__action__button card__action--follow"
        (click)="openPeepsoProfile(userDetails?.peepso_profile_url,'')">follow</button>
      <button class="card__action__button card__action--message"
        (click)="openPeepsoMessages('https://web.lottosocial.com/messages/')">message</button>
    </div>
  </div>
</main>